import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';

// Types
import { IContactInformationProps } from '../planSummary.types';

// Utils
import { phoneNumberTools } from '../../../../utils/tools/phoneNumberTools';

// Components
import { ConditionalRendering } from '../../../../components/common/conditional-rendering';

// Styles
import {
    StyledDd,
    StyledDl,
    StyledDt,
    StyledPlanSectionDataContainer,
    StyledPlanSectionHeader,
} from '../plansummary.styled';

const ContactInformation = memo(({ plan }: IContactInformationProps) => (
    <div data-testid="contact-info">
        <StyledPlanSectionHeader>
            <h5>
                <FormattedMessage id="plansummary.contactinformation" />
            </h5>
        </StyledPlanSectionHeader>
        <StyledPlanSectionDataContainer>
            <StyledDl>
                <StyledDt as="dt" data-testid="customer-phone-label">
                    <FormattedMessage id="plansummary.customerservice" />:
                </StyledDt>
                <StyledDd as="dd" data-testid="customer-phone-value">
                    {phoneNumberTools.formatPhoneNumber(plan.issuerContactPhone) || (
                        <FormattedMessage id="plansummary.na" />
                    )}
                </StyledDd>

                <StyledDt as="dt" data-testid="customer-web-label">
                    <FormattedMessage id="plansummary.web" />:
                </StyledDt>
                <ConditionalRendering isTrue={!!plan.issuerContactUrl}>
                    <StyledDd as="dd" data-testid="customer-web-value">
                        <a
                            href={plan.issuerContactUrl!}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="contact-url"
                        >
                            <u>
                                <FormattedMessage id="plansummary.clickhere" />
                            </u>
                        </a>
                    </StyledDd>
                </ConditionalRendering>
                <ConditionalRendering isTrue={!plan.issuerContactUrl}>
                    <StyledDd as="dd" data-testid="customer-web-na-value">
                        <FormattedMessage id="plansummary.na" />
                    </StyledDd>
                </ConditionalRendering>
            </StyledDl>
        </StyledPlanSectionDataContainer>
    </div>
));

ContactInformation.displayName = 'ContactInformation';
export default ContactInformation;
